/*
 * Free delivery bar (snippets/free-delivery-bar.liquid).
 * The amount is in the shop currency. For another currency it is converted with
 * Shopify.currency.rate and rounded up the same way as the market announcement bar,
 * so the cart shows the same amount as the bar. Checkout converts free-delivery amounts
 * without Shopify's currency conversion fee, so the fee (data-fx-fee, %) is taken off the rate
 * here to match checkout. The theme re-renders the cart after
 * every change, so each new <free-delivery-bar> element works out its own state.
 */
(function () {
  if (window.customElements.get('free-delivery-bar')) return;

  function step(value) {
    var base = value / 20;
    var power = Math.pow(10, Math.floor(Math.log10(base)));
    var unit = base / power;
    return (unit >= 5 ? 5 : unit >= 2 ? 2 : 1) * power;
  }

  function convert(amount, data) {
    var currency = (window.Shopify && window.Shopify.currency) || {};
    var active = data.currency || currency.active;
    if (!active || active === data.shopCurrency) return amount;
    // Page and cart in different currencies: no safe rate, so the bar hides.
    if (currency.active !== active) return null;
    var rate = parseFloat(currency.rate) || 1;
    var fee = parseFloat(data.fxFee) || 0;
    if (fee > 0) rate = rate / (1 + fee / 100);
    var value = amount * rate;
    if (data.rounding === 'exact') return value;
    var unit = data.rounding === 'whole' ? 1 : step(value);
    value = Math.ceil(value / unit - 1e-9) * unit;
    return Math.ceil(value - 1e-9);
  }

  function formatMoney(cents, format) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  // Cart tax/shipping line: swap "shipping calculated at checkout" for the free delivery
  // line (locale key in the section) once the cart qualifies, so the two never disagree.
  function setNotes(el, reached) {
    var scope = el.closest('cart-drawer, .shopify-section') || document;
    var notes = scope.querySelectorAll('[data-fdb-note]');
    if (!notes.length) notes = document.querySelectorAll('[data-fdb-note]');
    Array.prototype.forEach.call(notes, function (note) {
      note.hidden = note.getAttribute('data-fdb-note') === 'free' ? !reached : reached;
    });
  }

  class FreeDeliveryBar extends HTMLElement {
    connectedCallback() {
      this.update();
    }

    update() {
      var data = this.dataset;
      var remaining = this.querySelector('.free-delivery-bar__remaining');
      var success = this.querySelector('.free-delivery-bar__success');
      var bar = this.querySelector('progress-bar');
      var reached = data.state === 'free';
      var progress = 100;

      if (!reached) {
        var amount = parseFloat(data.amount);
        if (!(amount > 0)) {
          this.hidden = true;
          setNotes(this, false);
          return;
        }
        var value = convert(amount, data);
        if (value === null) {
          this.hidden = true;
          setNotes(this, false);
          return;
        }
        var threshold = data.rounding === 'exact'
          ? (/no_decimals/.test(data.format || '') ? Math.ceil(value - 1e-9) * 100 : Math.ceil(value * 100 - 1e-6))
          : Math.round(value * 100);
        var total = parseInt(data.total, 10) || 0;
        reached = total >= threshold;
        progress = reached ? 100 : Math.floor((total / threshold) * 100);
        if (!reached) {
          var target = this.querySelector('[data-fdb-remaining]');
          if (target) {
            var text = formatMoney(threshold - total, data.format || '{{amount}}');
            target.textContent = text.replace(/<[^>]*>/g, '');
          }
        }
      }

      if (remaining) remaining.hidden = reached;
      if (success) success.hidden = !reached;
      if (bar) {
        bar.style.setProperty('--progress', progress + '%');
        bar.setAttribute('aria-valuenow', progress);
        bar.classList.toggle('is-reached', reached);
      }
      setNotes(this, reached);
      this.classList.remove('is-pending');
    }
  }

  window.customElements.define('free-delivery-bar', FreeDeliveryBar);
})();
